const ShowroomIcon = ({ fill }) => {
	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 129.3 165.3"
			fill="var(--icons)"
			height="30px"
			width="30px"
		>
			<g>
				<g>
					<path d="M46,79.4c0.8-1.3,1.2-3,1.2-5v-7.7c0-3.6-1-6.2-2.9-7.8c-1.9-1.6-4.3-2.4-7.3-2.4H26.3c-1.6,0-2.9,1.3-2.9,2.9v47
						c0,1.6,1.3,2.9,2.9,2.9h10.9c2.9,0,5.3-0.8,7.2-2.4c1.9-1.6,2.9-4.2,2.9-7.8v-8.8c0-2-0.4-3.6-1.2-4.9c-0.8-1.3-2.2-2.3-4.2-3
						C43.8,81.7,45.2,80.8,46,79.4z M31.9,63.7h4.3c2,0,2.9,1.1,2.9,3.4v8.6c0,2.4-1.1,3.6-3.2,3.6h-4V63.7z M39.1,98.6
						c0,2.3-1,3.4-2.9,3.4h-4.4V85.8h4c2.2,0,3.2,1.2,3.2,3.7V98.6z"/>
				</g>
				<g>
					<path d="M67.1,87.6c3-3.6,5.1-6.9,6.5-9.9c1.4-3,2.1-6.2,2.1-9.7c0-1.7-0.2-3.4-0.6-4.9c-0.4-1.5-1.1-2.8-2-4
						c-0.9-1.1-2.1-2-3.6-2.7c-1.5-0.7-3.2-1-5.3-1c-1.8,0-3.4,0.3-4.7,1c-1.3,0.6-2.5,1.5-3.4,2.5c-0.9,1.1-1.6,2.3-2,3.6
						c-0.4,1.4-0.7,2.8-0.7,4.3v3.6c0,1.6,1.3,2.9,2.9,2.9h1.2c1.6,0,2.9-1.3,2.9-2.9v-3.2c0-1.4,0.3-2.5,1-3.4c0.7-0.8,1.6-1.2,3-1.2
						c2.7,0,4,1.6,4,4.7c0,1.3-0.1,2.6-0.4,3.8c-0.2,1.2-0.6,2.4-1.1,3.6c-0.5,1.2-1.2,2.5-2,3.8c-0.8,1.3-1.8,2.8-3,4.5
						c-1.9,2.9-3.4,5.4-4.6,7.6c-1.2,2.2-2.1,4.1-2.8,5.9c-0.7,1.8-1.1,3.5-1.4,5.1c-0.3,1.6-0.4,3.3-0.4,5.1v2.3h19.8
						c1.6,0,2.9-1.3,2.9-2.9v-1.7c0-1.6-1.3-2.9-2.9-2.9H61.2c0-1.6,0.4-3.5,1.3-5.6S64.8,91.2,67.1,87.6z"/>
				</g>
				<g>
					<path d="M104.5,79.4c0.8-1.3,1.2-3,1.2-5v-7.7c0-3.6-1-6.2-2.9-7.8c-1.9-1.6-4.3-2.4-7.3-2.4H84.8c-1.6,0-2.9,1.3-2.9,2.9v47
						c0,1.6,1.3,2.9,2.9,2.9h10.9c2.9,0,5.3-0.8,7.2-2.4c1.9-1.6,2.9-4.2,2.9-7.8v-8.8c0-2-0.4-3.6-1.2-4.9c-0.8-1.3-2.2-2.3-4.2-3
						C102.3,81.7,103.6,80.8,104.5,79.4z M90.3,63.7h4.3c2,0,2.9,1.1,2.9,3.4v8.6c0,2.4-1.1,3.6-3.2,3.6h-4V63.7z M97.6,98.6
						c0,2.3-1,3.4-2.9,3.4h-4.4V85.8h4c2.2,0,3.2,1.2,3.2,3.7V98.6z"/>
				</g>
				<g>
					<path d="M23.2,139c-8.2,0-14.9-6.7-14.9-14.9V41.2c0-8.2,6.7-14.9,14.9-14.9h61.7L72.4,38.9c-1.3,1.3-1.3,3.5,0,4.8
						c0.7,0.7,1.5,1,2.4,1s1.7-0.3,2.4-1l18.4-18.4c1.3-1.3,1.3-3.5,0-4.8L77.2,2.2c-1.3-1.3-3.5-1.3-4.8,0c-1.3,1.3-1.3,3.5,0,4.8
						l12.5,12.5H23.2c-12,0-21.7,9.7-21.7,21.7v82.8c0,12,9.7,21.7,21.7,21.7c1.9,0,3.4-1.5,3.4-3.4S25.1,139,23.2,139z"/>
				</g>
				<g>
					<path d="M106.1,19.5c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4c8.2,0,14.9,6.7,14.9,14.9v82.8c0,8.2-6.7,14.9-14.9,14.9H45.2
						l12.5-12.5c1.3-1.3,1.3-3.5,0-4.8c-1.3-1.3-3.5-1.3-4.8,0L34.6,140c-1.3,1.3-1.3,3.5,0,4.8l18.4,18.4c0.7,0.7,1.5,1,2.4,1
						s1.7-0.3,2.4-1c1.3-1.3,1.3-3.5,0-4.8l-12.5-12.5h60.8c12,0,21.7-9.7,21.7-21.7V41.2C127.8,29.3,118,19.5,106.1,19.5z"/>
				</g>
			</g>
		</svg>
	);
};

export default ShowroomIcon;
